let url = (new URL(document.URL));
let host = url.hostname
export const domain = host.replace('afiliado.', '')

export const rootUrl = 'https://api.'+domain+'/'
export const apiUrl = 'https://api.'+domain+'/afiliado/'
export const SCROLL = 200
export const auth_id = 4
export const auth_secret = '8NK8eBBxzUCuILkRTrlWEV7APB7aWi5DTaIm7a74'